import styled from 'styled-components'
import PanelButton from '@pc/components/Works/Panel/shared/button/PanelButton'

const FeaturePanelButton = styled(PanelButton)`
  min-width: 120px;
  height: 40px;
  width: 100%;
`

export default FeaturePanelButton
